"use client";

import { MouseEvent, useContext, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Badge, Button, Fade, Stack } from '@mui/material';
import TokenContext from '@/context/TokenProvider';
import { useNotifikasi, useProfile } from "@/utils/Hooks";
import Menu from "@mui/material/Menu";
import ProfileMenuContents from '@/components/ProfileMenu/ProfileMenuContents';
import NotifikasiScreenContents from "@/components/Notifikasi/NotifikasiScreenContents";

const UserNavbarTopRight = () => {
  const { accessToken, authenticatedFetcher } = useContext(TokenContext)!;

  const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenuAnchorEl = Boolean(profileMenuAnchor);

  const handleProfileClick = (event: MouseEvent<HTMLButtonElement>) => {
    setProfileMenuAnchor(event.currentTarget);
  };
  const handleProfileClose = () => {
    setProfileMenuAnchor(null);
  };

  const [notificationMenuAnchor, setNotificationMenuAnchor] = useState<null | HTMLElement>(null);
  const openNotificationMenuAnchorEl = Boolean(notificationMenuAnchor);

  const handleNotificationClick = (event: MouseEvent<HTMLButtonElement>) => {
    setNotificationMenuAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationMenuAnchor(null);
  };

  const { data: notifikasi } = useNotifikasi(authenticatedFetcher);
  const { data: profile } = useProfile(authenticatedFetcher);

  return (
    <Stack direction="row">
      {accessToken && <>
        <Box
          sx={{
            display: 'grid',
            margin: 'auto',
            height: '48px',
            width: '48px'
          }}
        >
          <IconButton
            id="notification-button"
            sx={{ p: 0 }}
            aria-controls={openProfileMenuAnchorEl ? 'notification-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openProfileMenuAnchorEl ? 'true' : undefined}
            onClick={handleNotificationClick}>
            {notifikasi && notifikasi?.count > 0 ? <Badge
              overlap="circular"
              badgeContent={notifikasi?.count}
              color="error"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              max={999}
            >
              <NotificationsOutlinedIcon/>
            </Badge> : <NotificationsOutlinedIcon/>
            }
          </IconButton>
          <Menu
            id="notification-menu"
            anchorEl={notificationMenuAnchor}
            open={openNotificationMenuAnchorEl}
            onClose={handleNotificationClose}
            slots={{
              transition: Fade
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              horizontal: 'right',
              vertical: 'top'
            }}
            slotProps={{
              paper: {
                sx: {
                  maxWidth: "400px",
                  width: "100%"
                }
              },
              list: {
                'aria-labelledby': 'basic-button'
              }
            }}
          >
            <NotifikasiScreenContents data={notifikasi?.rows ?? []} handleClose={handleNotificationClose}/>
          </Menu>
        </Box>
        <Box
          sx={{
            display: 'grid',
            margin: 'auto',
            height: '48px',
            width: '48px'
          }}
        >
          <IconButton
            id="profile-button"
            sx={{ p: 0 }}
            aria-controls={openProfileMenuAnchorEl ? 'profile-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openProfileMenuAnchorEl ? 'true' : undefined}
            onClick={handleProfileClick}>
            {profile?.kunjungan ? <Badge
              overlap="circular"
              badgeContent={profile?.kunjungan?.loker}
              variant={profile?.kunjungan?.loker ? 'standard' : 'dot'}
              color="error"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              max={999}
            >
              <Avatar alt="Foto profil" src={profile?.foto ? `${process.env.NEXT_PUBLIC_API_URL}/${profile.foto}` : undefined}/>
            </Badge> : <Avatar alt="Foto profil" src={profile?.foto ? `${process.env.NEXT_PUBLIC_API_URL}/${profile.foto}` : undefined}/>
            }
          </IconButton>
          <Menu
            id="profile-menu"
            anchorEl={profileMenuAnchor}
            open={openProfileMenuAnchorEl}
            onClose={handleProfileClose}
            slots={{
              transition: Fade
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              horizontal: 'right',
              vertical: 'top'
            }}
            slotProps={{
              paper: {
                sx: {
                  maxWidth: "400px",
                  width: "100%"
                }
              },
              list: {
                'aria-labelledby': 'basic-button'
              }
            }}
          >
            <ProfileMenuContents handleClose={handleProfileClose}/>
          </Menu>
        </Box>
      </>}
      {!accessToken && <Button variant="contained" href="/auth/login">
        Masuk
      </Button>
      }
    </Stack>
  );
};

export default UserNavbarTopRight;
